import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
    title: '',
    description: '',
    image: '',
    servings: '',
    prepTime: '',
    cookTime: '',
    price: '',
    isPaywall: false,
    ingredients: [],
    steps: [],
    photos: [],
  },
  itemDesign: {},
  containerDesign: {},
};

export const recipeSlice = createSlice({
  name: 'recipe',
  initialState,
  reducers: {
    recipeStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position ?? '',
        },
        title: blockContent?.title ?? '',
        description: blockContent?.description ?? '',
        image: blockContent?.image ?? '',
        servings: blockContent?.servings ?? '',
        prepTime: blockContent?.prepTime ?? '',
        cookTime: blockContent?.cookTime ?? '',
        price: blockContent?.price ?? '',
        isPaywall: blockContent?.isPaywall ?? false,
        ingredients: blockContent?.ingredients ?? [],
        steps: blockContent?.steps ?? [],
        photos: blockContent?.photos ?? [],
      };
    },
    recipeClear: () => initialState,

    recipeUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    recipeUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    recipeUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { recipeStore, recipeClear, recipeUpdateIsLoading, recipeUpdateIsActive, recipeUpdateBlockContent } =
  recipeSlice.actions;

export const selectRecipeIsLoading = (state) => state.recipe.isLoading;
export const selectRecipeId = (state) => state.recipe.id;
export const selectRecipeUID = (state) => state.recipe.uid;
export const selectRecipeSID = (state) => state.recipe.sid;
export const selectRecipeIsActive = (state) => state.recipe.isActive;
export const selectRecipeBlockContent = (state) => state.recipe.blockContent;
export const selectRecipeItemDesign = (state) => state.recipe.itemDesign;
export const selectRecipeContainerDesign = (state) => state.recipe.containerDesign;

export default recipeSlice.reducer;
